// Google Analytics utility functions
// This file provides helper functions for tracking events with Google Analytics

// Track page views
export const trackPageView = (pageName) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-FJ531CKKPY', {
      page_title: pageName,
      page_location: window.location.href
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Track form submissions
export const trackFormSubmission = (formName, formData = {}) => {
  trackEvent('form_submit', 'engagement', formName);
  
  // Track specific form data if provided
  if (formData.package) {
    trackEvent('package_selected', 'booking', formData.package);
  }
  if (formData.passengers > 0) {
    trackEvent('passengers_added', 'booking', `${formData.passengers} passengers`);
  }
  if (formData.addOns && formData.addOns.length > 0) {
    formData.addOns.forEach(addon => {
      trackEvent('addon_selected', 'booking', addon);
    });
  }
};

// Track button clicks
export const trackButtonClick = (buttonName, location) => {
  trackEvent('click', 'engagement', `${buttonName}_${location}`);
};

// Track section views (for scroll tracking)
export const trackSectionView = (sectionName) => {
  trackEvent('section_view', 'engagement', sectionName);
};

// Track external link clicks
export const trackExternalLink = (linkUrl, linkText) => {
  trackEvent('external_link_click', 'engagement', linkText, {
    link_url: linkUrl
  });
};

// Track booking funnel events
export const trackBookingStep = (step, stepData = {}) => {
  trackEvent('booking_step', 'conversion', step, stepData);
};

// Track pricing interactions
export const trackPricingInteraction = (action, packageType, price) => {
  trackEvent(action, 'pricing', packageType, price);
};

// Track contact interactions
export const trackContactInteraction = (method, context) => {
  trackEvent('contact', 'engagement', `${method}_${context}`);
};
